import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-vip-crown-line text-xl text-primary-500"></i>
            </span>
            <span
              className={`text-lg font-heading font-semibold whitespace-nowrap transition-colors ${
                isScrolled ? "text-foreground-900" : "text-white"
              }`}
            >
              女王调教指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isScrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white/80 hover:text-white"
              } ${location.pathname === "/" ? (isScrolled ? "text-primary-500" : "text-white") : ""}`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-foreground-700 hover:text-primary-500"
                    : "text-white/80 hover:text-white"
                } ${
                  location.pathname === `/category/${cat.slug}`
                    ? isScrolled
                      ? "text-primary-500"
                      : "text-white"
                    : ""
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isScrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white/80 hover:text-white"
              } ${location.pathname === "/about" ? (isScrolled ? "text-primary-500" : "text-white") : ""}`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              isScrolled ? "text-foreground-900" : "text-white"
            }`}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link
              to="/"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}